import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import { useDevice } from "../../../customHooks";
import style from "./style.module.css";
import Google from "./Google.svg";
import Twitter from "./Twitter.svg";
import Github from "./GitHub.svg";
import Dialog from "../../../../core/Dialog";
import { useState } from "react";
import * as LINKS from "../../../constants/Constants";

export const Social = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);

  return (
    <div className={style.no_account_wraper}>
      <div className={style.no_account_label}>
        <div className={style.no_account_line} />
        <Typography
          type="body"
          font="inter"
          //   color="primary"
          colorStep={50}
          tagName="div"
          small
          className={style.no_account_text}
        >
          No account? Register here
        </Typography>
        <div className={style.no_account_line} />
      </div>

      <div className={style.social_buttons}>
        <Button
          type="default"
          view="outlined"
          color="default"
          text={device !== "mobile" && "Github"}
          icon={<img src={Github} alt="" />}
          onClick={() => setOpen(true)}
        />
        <Button
          type="default"
          view="outlined"
          color="default"
          text={device !== "mobile" && "Google"}
          icon={<img src={Google} alt="" />}
          style={{ color: "#EA4335" }}
          onClick={() => setOpen(true)}
        />
        <Button
          type="default"
          view="outlined"
          color="default"
          text={device !== "mobile" && "Twitter"}
          icon={<img src={Twitter} alt="" />}
          style={{ color: "#1da1f2" }}
          onClick={() => setOpen(true)}
        />
      </div>
      <Dialog
        view="raised"
        icon="info-sign"
        title="Ready to use templates"
        text={
          "Setproduct Design System is a React-based UI toolkit for the web. Designed and well-organized in Figma. Optimized for building complex data-dense interfaces for desktop and mobile applications. This digital product contains both Figma design files (FIG) and React components (ZIP) and 60 ready-to-use web app templates"
        }
        backdropOpacity={20}
        leftButton={
          <a
            href={LINKS.FIGMA_DEMO_LINK}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Button
              type="default"
              view="outlined"
              dense={false}
              onClick={() => setOpen(false)}
              text="Preview in Figma"
            />
          </a>
        }
        rightButton={
          <a
            href={LINKS.BUY_LINK}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Button
              type="default"
              view="filled"
              dense={false}
              text="Purchase for $258"
            />
          </a>
        }
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        className={device === "mobile" ? style.dialog : ""}
      />
    </div>
  );
};
